import 'imagesloaded';
// import 'flickity-imagesloaded';

class SlidesSection {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: 4000,
            pageDots: false,
            wrapAround: true,
            // imagesLoaded: true,
            prevNextButtons: false,
            // setGallerySize: false,
            // fade: true,
            cellSelector: '.slides-slider__slide'
        };

        if(this.$el.length) {
            this._createSlider();
        }
    }

    _createSlider() {
        imagesLoaded(this.$el[0], (instance) => {console.log('loaded');
            this.$el.flickity(this.options);
        });
    }
}

export default SlidesSection;
